import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function ProtectedRoute({ children }) {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return isAuthenticated ? (
    children
  ) : (
    <>
    <div className="w-full flex flex-col items-center justify-center text-white">
      <h1 className="text-4xl text-white text-center font-semibold">Acceso Denegado</h1>
      <p className="text-xl">Aún no estás autenticado o no cuentas con los permisos necesarios</p>
      <p>Por favor, inicia sesión para continuar.</p>
      <div className="my-4">
        <FontAwesomeIcon icon="fa-solid fa-ban" className="text-6xl text-red-500" />
      </div>
      <p className="text-center space-y-4">
        Regresar al <Link to="/" className="block text-sm text-aw-bluedark font-semibold rounded-2xl bg-aw-green mt-2 p-2 hover:px-8 duration-300">Home</Link>
      </p>
    </div>
    </>
  );
}
